import { render, staticRenderFns } from "./messagesEmulator.vue?vue&type=template&id=1afeda93&"
import script from "./messagesEmulator.vue?vue&type=script&lang=js&"
export * from "./messagesEmulator.vue?vue&type=script&lang=js&"
import style0 from "./messagesEmulator.vue?vue&type=style&index=0&id=1afeda93&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports